import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import ScalpScanner from './components/ScalpScanner';

let internalToggle = null;
window.toggleScalpScanner = (show = true) => {
    if (internalToggle) {
        internalToggle(show);
    } else {
        console.warn("Scalp scanner is initializing, please wait...");
    }
};

const ScalpScannerApp = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Sync state with the global toggle
    React.useEffect(() => {
        internalToggle = (show) => {
            setIsVisible(show);
            document.body.style.overflow = show ? 'hidden' : 'auto';
        };
        return () => { internalToggle = null; };
    }, []);

    const handleComplete = (images) => {
        // images is an array of base64 strings
        console.log("Scalp Scan Complete:", images.length, "images captured");
        
        // Convert base64 to File objects to match Laravel's expected format
        const files = images.map((dataurl, idx) => {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], `scalp-ai-${Date.now()}-${idx}.jpg`, { type: mime });
        });

        // Dispatch specialized event for the Blade listener
        const event = new CustomEvent('scalpCaptureComplete', { detail: files });
        window.dispatchEvent(event);

        // Close scanner
        window.toggleScalpScanner(false);
    };

    if (!isVisible) return null;

    return (
        <ScalpScanner 
            onComplete={handleComplete} 
            onClose={() => window.toggleScalpScanner(false)} 
        />
    );
};

const rootElement = document.getElementById('scalp-scanner-root');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<ScalpScannerApp />);
}
